import { MouseEvent, useCallback, useState } from 'react';

export function useMenu() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const onOpen = useCallback((e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  }, []);

  const onClose = useCallback((e?: MouseEvent<HTMLElement>) => {
    e?.stopPropagation();
    setAnchorEl(null);
  }, []);

  return { anchorEl, open, onOpen, onClose };
}
